import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'countdown',
  pure: true
})

export class CharacterCountPipe implements PipeTransform {

  transform(text: string, args: number) {
    const maxLength = args || 0;
    const length = text ? text.length : 0;

    return (maxLength - length);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/character-count/character-count.ts